import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';
import { ProductNotReturnableViewComponent } from './views';

@Component({
  selector: 'ideal-product-not-returnable',
  imports: [ProductNotReturnableViewComponent],
  standalone: true,
  templateUrl: './product-not-returnable.component.html',
  styleUrl: './product-not-returnable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductNotReturnableComponent extends CommonProductDetailsComponentBase {
  public readonly line = input(false, { transform: booleanAttribute });

  protected initialized = signal(false);

  protected readonly isLoading = computed(() => !this.initialized() || !this.productId() || this.productDetails.loading());
  protected readonly isReturnable = computed(() => this.productDetails()?.returnable ?? true);
  /** Unknown (hidden) until the product details have loaded. */
  protected readonly returnable = computed(() => (this.isLoading() ? undefined : this.isReturnable()));

  public ngAfterViewInit(): void {
    this.initialized.set(true);
  }
}
